import type { FilterValues } from "./filter";

export const headers = [
  {
    key: "orderId",
    label: "Order ID",
  },
  {
    key: "businessName",
    label: "Business Name",
  },
  {
    key: "business",
    label: "Business Type",
  },
  {
    key: "orderDate",
    label: "Order Date",
  },
  {
    key: "customerName",
    label: "Customer Name",
  },
  {
    key: "totalAmount",
    label: "Total Amount",
  },
  {
    key: "partnerEarning",
    label: "Partner Earnings",
  },
  {
    key: "afpCommission",
    label: "My Earnings",
  },
];

export interface ServiceListSearchAndFiltersProps {
  onSearch: (searchText: string) => void;
  onFilterChange: (filters: FilterValues) => void;
  onResetFilters?: () => void;
  filterValues: FilterValues;
  placeholder?: string;
  appliedFiltersCount?: number;
  isFilterOpen?: boolean;
  setIsFilterOpen?: (isOpen: boolean) => void;
  searchRef?: React.RefObject<{
    clear: () => void;
    searchValue?: string;
  } | null>;
  isReset?: boolean;
  localSearchText?: string;
  createServiceHandler?: () => void;
}
